import { Types } from 'mongoose';
import * as r from './contribution-types.const';

export const CONTRIBUTION_TYPE = {
    type: 'Contribution Type',
    category: 'System',
    value: [
        {
            _id: new Types.ObjectId(r.CONTRIBUTION_TYPE_DONATED_TIME._id),
            label: r.CONTRIBUTION_TYPE_DONATED_TIME.label,
            description: r.CONTRIBUTION_TYPE_DONATED_TIME.description,
        },
        {
            _id: new Types.ObjectId(r.CONTRIBUTION_TYPE_FLAT._id),
            label: r.CONTRIBUTION_TYPE_FLAT.label,
            description: r.CONTRIBUTION_TYPE_FLAT.description,
        },
        {
            _id: new Types.ObjectId(r.CONTRIBUTION_TYPE_HOURLY._id),
            label: r.CONTRIBUTION_TYPE_HOURLY.label,
            description: r.CONTRIBUTION_TYPE_HOURLY.description,
        },
        {
            _id: new Types.ObjectId(r.CONTRIBUTION_TYPE_SALARIED_HOURLY._id),
            label: r.CONTRIBUTION_TYPE_SALARIED_HOURLY.label,
            description: r.CONTRIBUTION_TYPE_SALARIED_HOURLY.description,
        },
        {
            _id: new Types.ObjectId(r.CONTRIBUTION_TYPE_REIMBURSEMENT._id),
            label: r.CONTRIBUTION_TYPE_REIMBURSEMENT.label,
            description: r.CONTRIBUTION_TYPE_REIMBURSEMENT.description,
        },
    ].map(d => ({...d, active: true})),
};
